import { useTranslations } from 'contexts/Translation'
import PropTypes from 'prop-types'
import { Row, Col, Text } from '@qonsoll/react-design'
import { useState } from 'react'
import { useParams } from 'react-router-dom'
import { DesignSimpleView } from 'domains/Design/components'

const DesignList = (props) => {
  const { designs, isListWithCreate, listView, emptyProps, actions } = props

  // [COMPONENT_STATE_HOOKS]
  const [selectedItem, setSelectedItem] = useState(null)

  // [ADDITIONAL_HOOKS]
  const { t } = useTranslations()

  // [HANDLERS]
  const onEmptySpaceClick = () => setSelectedItem(null)

  return (
    <Row onClick={onEmptySpaceClick} mx={-3}>
      {designs?.length > 0 ? (
        designs?.map((design, index) => (
          <Col
            mb={4}
            key={design?._id || index}
            cw={listView ? 12 : [12, 6, 4]}>
            <DesignSimpleView
              actions={actions}
              index={index}
              isSelected={design?._id === selectedItem}
              onSelect={setSelectedItem}
              design={design}
            />
          </Col>
        ))
      ) : (
        <Col cw={isListWithCreate ? 'auto' : 12}>
          <Text variant="overline" type="secondary">
            {emptyProps?.message || t('No designs have been created yet')}
          </Text>
        </Col>
      )}
    </Row>
  )
}

DesignList.propTypes = {
  designs: PropTypes.array,
  isListWithCreate: PropTypes.bool,
  listView: PropTypes.bool,
  emptyProps: PropTypes.object,
  actions: PropTypes.shape({
    onEdit: PropTypes.func,
    onDelete: PropTypes.func,
    onDoubleClick: PropTypes.func,
    onClick: PropTypes.func
  })
}

export default DesignList
